import React from 'react';
import {Link} from 'react-router-dom';
import {imageUrl, calculatePackagePrice} from '../../helpers';
import {formatMoneyLegacy} from '../../utils/currency';

const Package = (props) => {
	const {aPackage} = props;
	var [price, discount] = calculatePackagePrice(aPackage);
	const cc = aPackage?.currency_code || 'NPR';
	// Clicking a package goes directly to inquiry form instead of /package/:id (package details bypassed).
	return (
		<Link to={`/inquiry_form/${aPackage.idx}`} className='card-widget link'>
			<div className=''>
				<figure>
					{aPackage.images && aPackage.images.length > 0 ? (
						<img src={imageUrl(aPackage.images[0].url)} alt={aPackage.name} className='img-responsive' />
					) : (
						<div className='placeholder-tour'>
							<i className='fas fa-mountain' aria-hidden='true' />
						</div>
					)}
				</figure>
				<div className='details'>
					<h3>{aPackage.name}</h3>
					<div className='d-flex justify-content-between align-items-center py-2'>
						<span className='text-small text-muted'>
							<i className='fas fa-map-marker-alt' />&nbsp;
							{aPackage.location}
						</span>
						<span className='text-small text-muted'>
							<i className='fas fa-clock' />&nbsp;
							{aPackage.duration}
						</span>
					</div>
					{discount > 0 && (
						<div>
							<span className='text-muted'>
								<del>{formatMoneyLegacy(aPackage.price || 0, cc)}</del>
							</span>

							<span className='text-success'> {discount} off</span>
						</div>
					)}
					<div>
						<span className='text-bold text-large'>{formatMoneyLegacy(price || 0, cc)}</span>
						<span className='text-small text-muted'> / person</span>
					</div>
				</div>
			</div>
		</Link>
	);
};

export default Package;
